import THEME from 'pobble-components/dist/theme'

const { COLORS } = THEME

export const mediaLoaderStyles = {
  img: {
    height: 'auto',
    background: '#fff',
    borderRadius: '8px',
    maxWidth: '724px',
    width: '100%'
  }
}

export const mediaPageNavStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '20px',
    color: '#fff',
    '& button': {
      cursor: 'pointer',
      color: '#fff',
      padding: '0',
      border: 'none',
      background: 'none',
      fontSize: '1.6em',
      '&:active': {
        color: COLORS.GREEN.NORMAL
      }
    },
    '& span': {
      fontSize: '0.8em',
      width: '3em',
      textAlign: 'center'
    }
  }
}

export default {}
